import webinarthumb1 from '../../assets/img/webinar_thumb1.png';
import webinarthumb2 from '../../assets/img/webinar_thumb2.png';
import webinarthumb3 from '../../assets/img/webinar123.png';
import webinarthumb4 from '../../assets/img/webinar_thumb4.png';
import webinarthumb5 from '../../assets/img/webinar_thumb5.png';
import webinarthumb6 from '../../assets/img/webinarthumb6.jpg';
import webinarthumb7 from '../../assets/img/webinarthumb7.png';
import webinarthumb8 from '../../assets/img/webinarthumb8.png';
import webinarthumb9 from '../../assets/img/webinarthumb9.png';
import webinarthumb10 from '../../assets/img/webinarthumb10.png';
import webinarthumb11 from '../../assets/img/webinarthumb11.jpg';
import { routes } from '../../containers/routes/routes-names';

export const WebinarCards = [
    {
        route: routes.webinar11,
        img: webinarthumb11,
        heading: `Stop Losing Candidates! Fix Ghosting with Offer Punching`,
        subject: `Hiring shouldn't be a guessing game. Untracked candidates, last-minute dropouts, and hiring uncertainty create chaos. In this session, Product Owner Santosh Boosem breaks down key challenges from ghosting to early attrition and shares strategies to bring accountability and predictability to hiring. Watch the full recording to see how instant offer alerts, two-way feedback, and structured insights can transform recruitment.`,
        date: 'February 28, 2025 - 11 AM IST',
    },
    {
        route: routes.webinar10,
        img: webinarthumb10,
        heading: `Stop Getting Ghosted: How to Keep Candidates Committed After They Say Yes!`,
        subject: `Learn how our founder, Krishna Padisetty, tackles candidate ghosting with OfferX's innovative solutions. Gain insights on instant offer alerts, two-way feedback, and proven retention strategies.`,
        date: 'November 26, 2024 - 11 AM IST',
    },
    {
        route: routes.webinar9,
        img: webinarthumb9,
        heading: `Frustrated by candidate backouts and unexpected exits?`,
        subject: `Missed the webinar? Watch the recording to discover OfferX's solution to
                                            reduce candidate backouts and unexpected exits. Transform your hiring and
                                            retention strategy today!`,
        date: 'October 29, 2024 - 11 AM IST',
    },
    {
        route: routes.webinar8,
        img: webinarthumb8,
        heading: `Eliminate Candidate Backouts and Unexpected Exits`,
        subject: `Tired of dealing with last-minute candidate withdrawals and unexpected
                                            employee exits? In this exclusive webinar recording, we introduce 
                                            <span className="fw-600">OfferX's Unified Solution</span> —a game-changer
                                            for HR professionals and recruiters looking to tackle these challenges
                                            head-on.`,
        date: 'September 25, 2024 - 11 AM IST',
    },
    {
        route: routes.webinar7,
        img: webinarthumb7,
        heading: `No More Candidate Backouts and Surprise Exits`,
        subject: `Catch the recording of our recent OfferX webinar, where we dive into a
                                            two-way reviewing platform designed to address these issues head-on.`,
        date: 'August 07, 2024 - 11 AM IST',
    },
    {
        route: routes.webinar6,
        img: webinarthumb6,
        heading: `Mastering Recruitment`,
        subject: `In this insightful webinar, we tackle the pressing issues facing HR
                                            professionals and hiring managers in today's competitive job market.`,
        date: 'June 12, 2024 - 11 AM IST',
    },
    {
        route: routes.webinar5,
        img: webinarthumb5,
        heading: `Prevent Candidate Backouts and Surprise Exits`,
        subject: `In this webinar, we've discussed the challenges of onboarding and
                                            offboarding within organizations and unveiled the key to preventing
                                            candidate backouts and mitigating departure risks.`,
        date: 'April 17, 2024 - 11 AM IST',
    },
    {
        route: routes.webinar4,
        img: webinarthumb4,
        heading: `<span className="fs-24">Say Goodbye To Candidate Backouts!!</span> <span className="fs-14">(Webinar with Krishna Padisetty)</span>`,
        subject: `Struggling with candidate ghosting? You're not alone. Candidate ghosting is
                                            common in today's job market, leaving employers puzzled. Watch the webinar
                                            for solutions and insights to prevent this phenomenon...`,
        date: 'February 20, 2024 - 11 AM IST',
    },
    {
        route: routes.webinar3,
        img: webinarthumb3,
        heading: 'Say Goodbye To Candidate Ghosting!! OfferX',
        subject: `Do you believe candidates should honour their joining commitment just as
                                            companies do? Then join us for this webinar and discover how to prevent
                                            candidate ghosting. The full webinar video is just a click away.`,
        date: 'November 21, 2023 - 11 AM IST',
    },
    {
        route: routes.webinar2,
        img: webinarthumb2,
        heading: 'Uniting HRs To Eliminate Candidate Ghosting!!',
        subject: `Tune in now to uncover powerful methods for combating candidate ghosting in
                                            our webinar created especially for HR professionals, recruiters, and talent
                                            acquisition experts. Let's come together to strengthen the HR community.`,
        date: 'October 05, 2023 - 11 AM IST',
    },
    {
        route: routes.webinar1,
        img: webinarthumb1,
        heading: 'No More Candidate Backouts - OfferX',
        subject: `Is your company tired of dealing with candidate backouts after they accept
                                            the job offer? Unfortunately, you are not alone. It has been a frustrating
                                            situation for many companies, but not anymore. Watch the webinar below for
                                            more details.`,
        date: 'August 09, 2023 - 11 AM IST',
    },
];
